import styled, { css } from 'styled-components';

interface IPropsInput {
  error: boolean;
}
interface IPropsContainer {
  sizeDisplay: 'lg' | 'sm' | 'md';
}

export const Container = styled.div<IPropsContainer>`
  position: relative;

  .input-icon-container {
    display: flex;
    align-items: center;
    justify-content: right;

    position: relative;

    svg {
      position: absolute;

      width: 20px;
      /* height: auto; */
      margin-right: 10px;
    }
  }

  ${(props) =>
    props.sizeDisplay === 'lg'
      ? css`
          width: 100%;
        `
      : props.sizeDisplay === 'md'
        ? css`
          width: calc(100% / 2 - 8px);
        `
        : css`
          width: calc(100% / 3 - 11px);
        `}
`;

export const Input = styled.input<IPropsInput>`
  border: 1px solid
    ${({ theme, error }) =>
    !error ? theme.colors.gray[400] : theme.colors.attention};
  border-radius: 8px;

  color: ${({ theme, error }) => error && theme.colors.attention};

  padding: 12px 16px;
  height: 48px;

  font-weight: 400;
  font-size: 12px;

  outline: none;

  width: 100%;

  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    border-color: ${({ theme, error }) =>
    error ? theme.colors.attention : theme.colors.orange.primary};
    box-shadow: 0 0 0 3px rgba(245, 128, 37, 0.15);
  }
`;

export const Error = styled.p`
  position: absolute;
  margin: 0;
  line-height: 100%;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.attention};
  bottom: -12px;
  left: 16px;
`;
